import Vue from 'vue'
import App from './App.vue'
import MeterPan from "./components/MeterPan/MeterPan";
const Components={
  MeterPan
}
Object.keys(Components).forEach(name=>{
  Vue.component(name,Components[name])
})
export default Components
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
